
function Avatar({person, size}){

    const s = (size || 50);
    const f = Math.round(s / 2.4);
    const st = s + 'px';
    const ft = f + 'px';

    const style = {
        width: st,
        minWidth: st,
        height: st,
        minHeight: st,
        fontSize: ft,
        backgroundColor: person.category?.color
    };

    return <div className="person-avatar" style={style}>
        <span>{person.initials}</span>
    </div>
}

export default Avatar;